<template>
    <dashboard-layout>
        <div class="row">
            <div class="col-lg-4 mb-4">
                <div class="card rounded shadow border-0 p-4 mb-3">
                    <form @submit.prevent="getResults">
                        <div class="mb-3">
                            <label class="form-label">Comment type</label>
                            <div>
                                <div v-for="(option, index) in commentTypes" :key="index" class="form-check">
                                    <input class="form-check-input" type="radio" :name="option.name" :id="option.id" :value="option.value" v-model="q.comment_type">
                                    <label class="form-check-label" :for="option.id">{{ option.label }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Sort order</label>
                            <div>
                                <div v-for="(option, index) in sortOrders" :key="index" class="form-check">
                                    <input class="form-check-input" type="radio" :name="option.name" :id="option.id" :value="option.value" v-model="q._order_by">
                                    <label class="form-check-label" :for="option.id">{{ option.label }}</label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-lg-8 mb-4">

                <div class="card rounded shadow border-0 p-4 mb-3" v-for="item in items?.data" :key="item.id" v-if="items?.data?.length > 0 ">
                    <div class="d-flex justify-content-between mb-4">
                        <h6 class="mb-0 text-muted">{{ item.question?.question }}</h6>
                        <div class="text-end">
                            <span class="text-muted mb-0">{{ item?.created_at }}</span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-html="item.comment"></div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex gap gap-1">

                            <a  href="javascript:void(0)" class="btn btn-sm btn-primary" @click="setDiscussion(item)"
                                data-bs-toggle="modal" data-bs-target="#discussionModal" >Show thread</a>

                            <a  href="javascript:void(0)" class="btn btn-sm btn-outline-danger" @click="deleteDiscussion(item)">Delete</a>

                        </div>
                        <div class="d-flex gap gap-1">

                            <a  href="javascript:void(0)" class="btn btn-sm btn-soft-warning" @click="setQuestion(item)"
                                data-bs-toggle="modal" data-bs-target="#questionModal"
                            v-if="item.question !== null ">View Question</a>

<!--                            <div class="btn btn-sm btn-soft-danger">-->
<!--                                View notes-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
                <div class="card rounded shadow border-0 p-4 mb-3" v-else>
                    <div class="text-center">
                        <h6 class="mb-0 text-muted">
                            No Comment threads found
                        </h6>
                    </div>
                </div>

                <discussion-modal :discussion="currentDiscussionItem"  />
                <question-modal :question="currentQuestionItem"  />

                <Bootstrap5Pagination
                    class="mb-0"
                    :data="items"
                    :limit="2"
                    :show-disabled="false"
                    :size="'default'"
                    :align="'center'"
                    @pagination-change-page="getResults"
                />
            </div>
        </div>
    </dashboard-layout>
</template>

<script>

import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import DashboardLayout from "../../dashboard-layout.vue";
import  discussionModal from "./discussion-modal.vue";
import  questionModal from "./question-modal.vue";

const toast = useToast();

export default {
    components: {
        DashboardLayout,
        Bootstrap5Pagination,
        discussionModal,
        questionModal
    },
    data() {
        return {
            currentQuestionItem: [],
            currentDiscussionItem: [],
            items: [],
            q: this.$route.query,
            form_options: {},
            commentTypes: [
                { name: 'comment_type', id: 'comment-type-all', value: 'all', label: 'All' },
                { name: 'comment_type', id: 'comment-type-started', value: 'started', label: "Thread you've started" },
                { name: 'comment_type', id: 'comment-type-response', value: 'response', label: "Responses you've made" },
            ],
            sortOrders: [
                // { name: 'sort', id: 'sort-latest', value: 'latest', label: 'Latest' },
                { name: 'sort', id: 'sort-date', value: 'date', label: 'By date' },
                { name: 'sort', id: 'sort-rating', value: 'rating', label: 'By rating' },
            ],
        }
    },
    created() {
        this.getResults();
    },
    watch: {
        'q': {
            handler: function (newValue) {
                this.getResults(1);
            },
            deep: true
        }
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {
            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('question_discussions/my_discussions', {params: {
                    'page': page,
                    ...this.q,
                    'subscribe_id': this.$route?.params?.subscribe_id
                }}).then(response => {
                toast.dismiss(id);
                this.items = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
        setDiscussion(item){
            if(item?.discussion !== null){
                this.currentDiscussionItem = item.discussion;
            }else{
                this.currentDiscussionItem = item;
            }
        },
        deleteDiscussion(item){
            // delete with confirm
            if(confirm('Are you sure you want to delete this discussion?')){

                const toastId = toast.info('Deleting discussion ...',{ icon: 'fa-solid fa-download' });
                axios.delete(`question_discussions/${item.id}`,  {params: {
                        'subscribe_id': this.$route?.params?.subscribe_id
                    }}).then(response => {
                    toast.dismiss(toastId);
                    let i = this.items.data.map(v => v.id).indexOf(item.id);
                    this.items.data.splice(i, 1)

                }, response => {
                    toast.dismiss(id);
                });
            }
        },
        setQuestion(item){
            this.currentQuestionItem = item?.question;
        }
        // show(item_id) {
        //
        //     const id = toast.info('Getting content ...',{ icon: 'fa-solid fa-download' });
        //
        //     axios.get(`question_discussions/${item_id}`, {}).then(response => {
        //
        //         this.currentDiscussionItem = response.data.data;
        //
        //         toast.dismiss(id);
        //     }, response => {
        //         toast.dismiss(id);
        //     });
        // },
    }
}
</script>
